import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { ImportSkillsApplyResult } from '@core/tellent-skills-types';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogComponentI,
  DialogRef,
  HeadingComponent,
  IconComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-import-skills-result-dialog',
  templateUrl: './import-skills-result-dialog.component.html',
  styleUrl: './import-skills-result-dialog.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, DialogBodyComponent, IconComponent, TranslatePipe, HeadingComponent],
})
export class ImportSkillsResultDialogComponent implements DialogComponentI<
  { applyResult?: ImportSkillsApplyResult },
  { back: true }
> {
  private readonly dialogRef = inject(DialogRef);

  protected readonly applyResult = signal<ImportSkillsApplyResult | null>(null);
  protected readonly skillsCount = computed(() => {
    const result = this.applyResult();
    return result?.success ? result.skillsCount : 0;
  });
  protected readonly positionsCount = computed(() => {
    const result = this.applyResult();
    return result?.success ? result.positionsCount : 0;
  });

  public setDialogData(
    data: { applyResult?: ImportSkillsApplyResult },
    _triggerUpdate: boolean,
  ): void {
    if (data.applyResult) {
      this.applyResult.set(data.applyResult);
    }
  }

  public reviewAndTryAgain(): void {
    this.dialogRef.close({ back: true });
  }

  public close(): void {
    this.dialogRef.close();
  }
}
